/**
 * IVP - Player element init.
 * @return {object} The video element
 */
export default function init_player_el() {
  // Set video element
  const playerEl = document.createElement('video-js');

  // Set video element classes
  playerEl.classList.add('webobject');
  playerEl.classList.add('video-js');
  playerEl.classList.add('vjs-default-skin');
  playerEl.classList.add('vjs-big-play-centered');
  //playerEl.classList.add('vjs-show-big-play-button-on-pause');
  playerEl.classList.add('ivp');

  // Style video element
  playerEl.border = '0';
  playerEl.cellspacing = '0';
  playerEl.style.width = '100%';
  playerEl.style.height = '100%';
  playerEl.style.position = 'absolute';
  playerEl.style.left = '0px';
  playerEl.style.top = '0px';

  return playerEl;
}
